<div class="gt-routes-list-containerss" style="position: relative">
  <app-gpd-button
    icon="add"
    i18n-text="@@add"
    text="Add"
    (onClick)="addCategory()"
  ></app-gpd-button>

  <dx-tree-list
    #treelist
    parentIdExpr="primaryCategoryId"
    keyExpr="id"
    [dataSource]="treeDataSourceSorted"
    loadPanel="visible"
    class="form-style gt-flex-dir-col taskConfigForm"
    showRowLines="true"
    displayExpr="categoryName"
    [allowColumnResizing]="true"
    [columnResizingMode]="'widget'"
    [columnAutoWidth]="false"
    [showBorders]="true"
    [scrolling]="{ mode: 'standard', useNative: true }"
    [width]="'100%'"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    (onEditingStart)="setEditData($event)"
    (onContextMenuPreparing)="!editData ?  showContextMenu($event): null"
  >
    <dxo-row-dragging
      [allowReordering]="true"
      [showDragIcons]="true"
      [allowDropInsideItem]="true"
      [cursorOffset]="{ x: 10, y: 10 }"
      [onReorder]="rowReordered"
      [onDragStart]="onRowDragMove"
    ></dxo-row-dragging>

    <dxo-search-panel
      [visible]="true"
      [highlightCaseSensitive]="false"
      class="gt-search-panel search-float-off-toolbar"
      width="17vw"
      i18n-placeholder="@@search..."
      placeholder="Search..."
    >
    </dxo-search-panel>

    <dxo-scrolling mode="virtual"></dxo-scrolling>

    <dxo-toolbar>
      <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
      <dxi-item width="50%">
        <div class="gt-flex-dir-row">
          <!-- Add buttons here if needed -->
        </div>
      </dxi-item>
    </dxo-toolbar>

    <dxo-editing mode="form" [confirmDelete]="false">
      <dxo-form colCount="1">
        <dxi-item template="taskConfigForm">
          <div *dxTemplate="let item of 'taskConfigForm'">
            <form (submit)="$event.preventDefault(); writeCategory($event)">
              <dx-form
                [formData]="editData"
                [colCount]="1"
                validationGroup="taskConfigForm"
              >
                <dxi-item itemType="group" [colCount]="2">
                  <dxi-item
                    *ngIf="editData.itemLevel != 1"
                    [colSpan]="2"
                    dataField="categoryName"
                    editorType="dxTextBox"
                    caption="Category Name"
                    [validationRules]="[{ type: 'required', message: titleRequired }]"
                  >
                    <dxo-label i18n-text text="Title" />
                  </dxi-item>

                  <dxi-item
                    *ngIf="editData.itemLevel == 1"
                    [colSpan]="1"
                    dataField="categoryName"
                    editorType="dxTextBox"
                    caption="Category Name"
                    [validationRules]="[{ type: 'required', message: titleRequired }]"
                  >
                    <dxo-label i18n-text text="Title" />
                  </dxi-item>

                  <dxi-item
                    *ngIf="editData.itemLevel == 1"
                    [colSpan]="1"
                    dataField="departmentId"
                    editorType="dxSelectBox"
                    [editorOptions]="{
                                            dataSource: departmentsList,
                                            valueExpr: 'id',
                                            displayExpr: 'departmentName'
                                        }"
                    [validationRules]="[{ type: 'required', message: departmentRequired }]"
                  >
                    <dxo-label i18n-text text="Department" />
                  </dxi-item>

                  <dxi-item
                    *ngIf="isNewCategory"
                    dataField="departmentId"
                    editorType="dxSelectBox"
                    [editorOptions]="{
                                            dataSource: projectCostCategories,
                                            valueExpr: 'itemLevel',
                                            displayExpr: 'departmentName'
                                        }"
                  >
                    <dxo-label i18n-text text="Department" />
                  </dxi-item>

                  <dxi-item
                    itemType="group"
                    [colSpan]="2"
                    cssClass="buttons-group"
                    [verticalAlignment]="true"
                  >
                    <app-gpd-button
                      type="secondary"
                      i18n-text="@@cancel"
                      text="Cancel"
                      [useSubmitBehavior]="false"
                      (onClick)="onEditCanceling()"
                    ></app-gpd-button>

                    <app-gpd-button
                      icon="tick"
                      i18n-text="@@confirm"
                      text="Confirm"
                      validationGroup="taskConfigForm"
                      [useSubmitBehavior]="true"
                    ></app-gpd-button>
                  </dxi-item>
                </dxi-item>
              </dx-form>
            </form>
          </div>
        </dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxi-column
      i18n-caption
      caption="Category"
      dataField="categoryName"
    ></dxi-column>

    <dxi-column
      i18n-caption
      caption="Department"
      dataField="departmentId"
      [editCellTemplate]="'editDepartemntTempalte'"
    >
      <dxo-lookup
        [dataSource]="departmentsList"
        valueExpr="id"
        displayExpr="departmentName"
      ></dxo-lookup>
      <div *dxTemplate="let data of 'editDepartemntTempalte'">
        <dx-select-box
          [dataSource]="departmentsList"
          valueExpr="id"
          displayExpr="departmentName"
        ></dx-select-box>
      </div>
    </dxi-column>

    <dxi-column
      dataField="none"
      caption
      cellTemplate="buttonCellTemplate"
      width="100px"
      [formItem]="{ visible: false }"
      [allowHeaderFiltering]="false"
    >
      <div *dxTemplate="let item of 'buttonCellTemplate'">
        <div class="gpd-table-actions">
            <app-svg-icon icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" i18n-title="@@edit" title="Edit" (click)="editSelectedRow(item)"></app-svg-icon>
            <app-svg-icon icon="delete" color="var(--color-red-500)" [size]="20" [strokeWidth]="1.5" i18n-title="@@delete" title="Delete" (click)="deleteItem(item)"></app-svg-icon>
        </div>
      </div>
    </dxi-column>
  </dx-tree-list>

  <app-delete-popup
    [visible]="deletePopupVisible"
    (onAbort)="onDeleteAbort()"
    [message]="deletePopupMessage"
    (onConfirm)="onDeleteSelection()"
  ></app-delete-popup>

  <dx-toast
    [(visible)]="toastVisible"
    [message]="toastMessage"
    [type]="type"
  ></dx-toast>
</div>
